
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

function Header() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header id="masthead" className={`site-header ${scrolled ? 'scrolled' : ''}`} role="banner">
      <div className="language-selector-wrapper">
        <LanguageSelector />
      </div>
      <div className="site-branding">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 'var(--spacing-6)', position: 'relative' }}>
          <Link to="/" rel="home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flexShrink: 0, position: 'absolute', left: 0 }}>
            <img
              src="/logo.png"
              alt="RIVE Accueil"
              className="site-logo"
            />
          </Link>

          <nav id="site-navigation" className="main-navigation">
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-text">
            {menuOpen ? t('header.menuClose') : t('header.menuToggle')}
          </span>
        </button>
        <ul className={`menu ${menuOpen ? 'active' : ''}`}>
          <li className="menu-item">
            <Link to="/">{t('header.home')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/notre-histoire">{t('header.ourStory')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/notre-equipe">{t('header.ourTeam')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/nos-actions">{t('header.ourActions')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/regles-de-vie">{t('header.rules')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/renseignements-pratiques">{t('header.practicalInfo')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/partenaires">{t('header.partners')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/actualites">{t('header.news')}</Link>
          </li>
          <li className="menu-item">
            <Link to="/donations">{t('header.donate')}</Link>
          </li>
        </ul>
        <form role="search" method="get" className="search-form" onSubmit={(e) => e.preventDefault()}>
          <label>
            <span className="screen-reader-text">{t('header.search')}:</span>
            <input
              type="search"
              className="search-field"
              placeholder={t('header.search')}
              name="s"
            />
          </label>
          <input type="submit" className="search-submit" value={t('header.searchButton')} />
        </form>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
